module.exports = {
  "lang_1": "繁体",
  "lang_2": "简体",
  "lang_3": "English",
  "lang_4": "日本语",
  "home_0": "首页",
  "home_000": "生鲜购物网",
  "home_001": "八方云集(美国)",
  "home_00": "投资人专区",
  "home_01": "慈善基金会",
  "home_02": "ESG",
  "home_1": "安心餐点",
  "home_2": "企业简介",
  "home_3": "最新消息",
  "home_4": "联络我们",
  "home_5": "快速搜寻门市",
  "home_5_0": "门市搜寻",
  "home_5_1": "快速搜寻门市",
  "home_5_2": "进阶搜寻",
  "home_6": "语言 / 繁体 (切换)",
  "home_7": "坚持新鲜食材当天制作、当天运送",
  "home_8": "食材的坚持",
  "home_9": "新品上市",
  "home_10": "契作农场新鲜蔬菜 (应该有很多品项)",
  "home_11": "门市快速搜寻",
  "home_12": "给消费者最方便、最快速的门市搜寻",
  "home_13": "输入你想要搜寻的县市、地址、门店名字",
  "home_14": "台湾的县市 请参阅第二张表",
  "home_15": "立即搜寻",
  "home_16": "打造幸福企业",
  "home_17": "新鲜美味的食材 ",
  "home_18": "“契作生产、日日配送”",
  "home_19": "营造安稳事业",
  "home_20": "“只要肯努力，水饺也能变元宝”",
  "home_21": "打造庶民连锁餐饮品牌",
  "home_22": "“铜板美食、产品多样”",
  "home_23": "食安的坚持",
  "home_24": "从研发口味道到检测食材、配送过程，我们都坚持透过最专业的科技，提供最新鲜、卫生、优良的产品，让消费者吃得安心。",
  "home_25": "品质认证",
  "home_26": "食安检测",
  "home_27": "食安政策",
  "home_28": "最新消息",
  "home_29": "详细内容",
  "home_30": "安心餐点",
  "home_31": "锅贴系列",
  "home_32": "水饺系列",
  "home_33": "干面系列",
  "home_34": "汤面系列",
  "home_35": "抄手系列",
  "home_36": "汤品系列",
  "home_37": "饮品系列",
  "home_38": "小菜系列",
  "home_39": "生鲜系列",
  "home_40": "检验报告",
  "home_41": "相关连结",
  "home_42": "香港八方云集",
  "home_43": "Facebook",
  "home_44": "八方云集基金会",
  "home_45": "SGS安心平台",
  "home_46": "投资人专区",
  "home_47": "服务电话",
  "home_48": "公司地址",
  "home_49": "新北市淡水区中正东路二段27号18楼",
  "home_50": "卡路里/克",
  "home_51": "蛋白质",
  "home_52": "脂肪",
  "home_53": "碳水化合物",
  "home_54": "浏览纪录",
  "home_55": "观看",
  "home_56": "梁社汉排骨",
  "home_57": "芳珍蔬食",
  "home_58": "八方云集(美国)",
  "company_1": "经营理念",
  "company_2": "食安政策",
  "company_3": "品质认证",
  "company_4": "大事纪",
  "company_5": "区域布局",
  "company_6": "公司治理",
  "company_7": "董事会",
  "company_7_0": "董事成员",
  "company_8": "企业社会责任",
  "company_9": "台湾生产据点",
  "company_10": "利他、分享、公益",
  "company_11": "八方云集从创立至今一直秉持着「利他、分享、公益」的精神，协助肯努力的弱势工作者开创生机，也让这些弱势者得以温饱、改善生活，应证了「只要肯努力，水饺也能变元宝」的理念。同时我们也提供了消费者安全、 新鲜、美味、平价的餐点及安心饮食的用餐环境，消费者用铜板价就能享用的庶民饮食。",
  "company_12": "八方云集以国外先进的生产设备进行全自动化生产，严格控管作业质量，包括制造、冷藏、低温配送、支持系统等，全面进行标准化管理。自2010年起取得食品安全管制系统HACCP认证，近期更取得ISO22000的认证。包括原料及产品均透过自主实验室、SGS或全国公证第三方同步检测，为食安做三层的把关。",
  "company_13": "除了HACCP及ISO22000的认证外，八方云集也获得新北市政府食品业者卫生优良奖章，此外八方云集是第一家登录SGS安心平台的中式餐饮，同时也针对餐桌上的产品进行抽检，消费者都可以在安心平台上看到每年3,000张的抽验结果，让消费者吃得安心。",
  "company_14_0": "1998年",
  "company_14": "开设第一家八方云集门市",
  "company_15_0": "2003年",
  "company_15": "门市高达100家",
  "company_16_0": "2008年",
  "company_16": "进入香港市场，同年于香港开设5间门市",
  "company_17_0": "2014年",
  "company_17": "福州工厂建置完成，正式进军大陆市场",
  "company_18_0": "2019年",
  "company_18": "正式发展新品牌梁社汉排骨全台开幕店数32间，集团海内外总店数来达1,171家门市",
  "company_19_0": "台湾锅贴水饺店连锁餐饮",
  "company_19_1": "1. 两处中央工厂坐落于新北市淡水与高雄凤山。",
  "company_19_2": "2. 一座蔬菜截切厂坐落于西螺",
  "company_19_3": "3. 全省门店超过1000间，以加盟为主，直营店亦稳健成长中",
  "company_20_0": "香港台式餐饮连锁",
  "company_20_1": "1. 一间中央工厂坐落于香港新界",
  "company_20_2": "2. 超过70间门市，以直营、委托经营与加盟并行的方式，强化通路的布建。",
  "company_21": "八方云集致力建置完整的公司治理架构，强化董事会职能，并保障股东权益，考虑公司整体营运以及因应内外在环境变迁，于2020年设置独立董事，进一步落实执行有效的公司治理。",
  "company_22": "八方云集董事会由在财金、产业、管理、法律等领域具有丰富经验的专业经理人所组成。",
  "company_23": "八方云集为实践企业社会责任，并促成经济、环境及社会之进步，以达永续发展之目标。",
  "company_23_1_2": "财团法人新北市私立",
  "company_23_1_1": "八方云集社会福利慈善事业基金会",
  "company_23_1": "详细内容",
  "company_23_2_1": "Sustainability Report",
  "company_23_2": "永续报告书",
  "company_23_3": "下载2021年永续报告书",
  "company_23_4": "下载2022年永续报告书",
  "company_24": "淡水一厂",
  "company_25": "制皮制馅原料生产自动化，金属探测器严格把关，香醇现磨浓醇豆浆，高标准坚守质量始终如一",
  "company_26": "淡水二厂",
  "company_27": "美味小菜、独门酱料研制的秘密基地",
  "company_28": "西螺截切蔬菜厂",
  "company_29": "一天使用超过35顿的高丽菜采收后冰水清洗确保鲜度及脆度",
  "company_30": "高雄一厂:",
  "company_31": "馅料、豆浆、红茶自动化生产线每天配送",
  "company_32": "高雄二厂:",
  "company_33": "压模制皮全自动南北供货无缝接轨新鲜每日送达",
  "company_34_0": "2020年",
  "company_34": "取得丹堤咖啡食品股份有限公司 69%股权，增加集团多元化经营",
  "company_35_0": "2021年",
  "company_35": "正式发展新品牌芳珍蔬食",
  "company_35_1": "于台湾证券交易所挂牌上市",
  "company_36_0": "2022年",
  "company_36": "美国「八方云集」首家门店于 3 月 25 日于加州开幕，营运版图跨出亚洲市场",
  "company_36_1": "启用屯山厂",
  "company_37_0": "2023年",
  "company_37": "美国八方云集门市达六间",
  "company_37_1": "芳珍蔬食达44间门市",
  "company_38_0": "美国南加州台式餐饮连锁",
  "company_38_1": "一间中央工厂，坐落于南加州尔湾（Irvine）区域",
  "company_38_2": "10间门市，以直营为主",
  "company_39_0": "2024",
  "company_39": "于台北国际牛肉面节 - 鲜食组红烧竞赛荣获「金牌奖」",
  "company_39_1": "集团海内外总店数超过1,300间",
  "investor_01":"组织架构",
  "investor_02":"董事会",
  "investor_03":"审计委员会",
  "investor_04":"薪酬委员会",
  "investor_05":"风险管理组织架构",
  "investor_06":"公司制度规范",
  "investor_07":"公司治理运作情形",
  "investor_08":"内部稽核组织及运作",
  "investor_09":"与独立董事沟通情形",
  "investor_10":"诚信经营落实情形",
  "investor_11":"防范内线交易管理落实情形",
  "investor_12":"信息安全",

  "investor_21":"每月营收",
  "investor_22":"财务报表",
  "investor_23":"重要财务比率",

  "investor_24":"主要股东",
  "investor_25":"股东会及年报",

  "investor_26":"股利政策",
  "investor_27":"法说会",
  "investor_28":"重大讯息与公告",

  "investor_001":"董事会多元化及独立性",
  "investor_002":"本公司为健全董事会结构，于「公司治理实务守则」中明订董事会成员组成应考虑多元化，并就本身运作、营运形态及发展需求，拟订适当之多元化方针，包括但不限于性别、年龄、国籍、文化及专业知识技能，而董事成员应具备之能力如下：(1)营运判断能力、(2)会计及财务分析能力、(3)经营管理能力、(4)危机处理能力、(5)产业知识、(6)国际市场观、(7)领导能力、(8)决策能力。",
  "investor_003":"本公司现任董事会由8位董事组成，董事遴选以专业、多元为基本原则，背景包含企业管理、经济、财务、法律、信息等领域，均具有专业背景及经营管理实务经验。其中独立董事4位，独立董事比例44%，具员工身份之董事比例12.5%，董事间具有配偶或二亲等以内之亲属关系者比例25%，女性董事37.5%，个别董事落实董事会成员多元化政策之情形如下：",
  "investor_004":"职称",
  "investor_005":"姓名",
  "investor_006":"国籍",
  "investor_007":"性别",
  "investor_008":"年龄",
  "investor_009":"兼任员工",
  "investor_010":"独立董事任期",
  "investor_011":"具备之能力",
  "investor_012":"营运判断能力",
  "investor_013":"会计及财务分析能力",
  "investor_014":"经营管理能力",
  "investor_015":"危机处理能力",
  "investor_016":"产业知识",
  "investor_017":"国际市场观",
  "investor_018":"领导能力",
  "investor_019":"决策能力",
  "investor_020":"董事长",
  "investor_021":"林欣怡",
  "investor_022":"中华民国",
  "investor_023":"女",
  "investor_024":"董事",
  "investor_025":"林家钰",
  "investor_026":"男",
  "investor_027":"林明哲",
  "investor_028":"张瑞莲",
  "investor_029":"高秀英",
  "investor_030":"独立董事",
  "investor_031":"邱士芳",
  "investor_032":"萧玉娟",
  "investor_032_0":"張明輝",
  "investor_033":"饶世湛",
  "investor_034":"吴升奇",
  "investor_035":"3年以下",
  "investor_035-1":"3-6年",
  "investor_02001":"具体管理目标与达成情形如下：",
  "investor_02002":"管理目标",
  "investor_02003":"达成情形",
  "investor_02004":"兼任经理人之董事不宜逾董事席次三分之一",
  "investor_02005":"独立董事席次达董事席次三分之一以上",
  "investor_02006":"适足多元之专业知识与技能",
  "investor_02007":"至少包含一位女性董事",
  "investor_02008":"二分之一以上独立董事其连续任期不超过三届",
  "investor_02009":"已达成",
  "investor_036":"本公司于109 年6月24日股东会设立审计委员会取代监察人，最近年度(109 年度)截至110/4/27日止，审计委员会开会共6次(A)，出席情形如下：",
  "investor_037":"审计委员会之运作，以下列事项之监督为主要目的：",
  "investor_038":"财务报表",
  "investor_039":"稽核及会计政策与程序",
  "investor_040":"内部控制制度暨相关之政策与程序",
  "investor_041":"重大之资产或衍生性商品交易",
  "investor_042":"重大资金贷与背书或保证",
  "investor_043":"募集或发行有价证券",
  "investor_044":"衍生性金融商品及现金投资情形",
  "investor_045":"法规遵循",
  "investor_046":"经理人与董事是否有关系人交易及可能之利益冲突",
  "investor_047":"签证会计师资历、独立性及绩效评量",
  "investor_048":"签证会计师之委任、解任或报酬",
  "investor_049":"财务、会计或内部稽核主管之任免",
  "investor_050":"审计委员会职责履行情形",
  "investor_051":"审计委员会绩效评量自评问卷等",
  "investor_052":"第二届委员任期：112年6月15日至115年6月14日，截至112年12月31日，已开会3次 (A)，委员出席情形如下：",
  "investor_053":"实际出席次数",
  "investor_054":"委托出席次数",
  "investor_055":"实际出席率",
  "investor_056":"备注",
  "investor_057":"其他应记载事项：",
  "investor_058":"一、审计委员会之运作如有下列情形之一者，应叙明审计委员会召开日期、期别、议案内容、独立董事反对意见、保留意见或重大建议项目内容、审计委员会决议结果以及公司对审计委员会意见之处理：",
  "investor_059":"(一)证券交易法第14条之5所列事项",
  "investor_060":"届次",
  "investor_061":"会议日期",
  "investor_0611":"会议时间",
  "investor_0612":"说明",
  "investor_0613":"简报下载",
  "investor_0614":"影片连结",
  "investor_062":"议案内容",
  "investor_063":"独立董事反对意见、保留意见或重大建议项目内容",
  "investor_064":"审计委员会决议结果",
  "investor_065":"独公司对审计委员会意见之处里",

  "investor_066":"第一届第五次",
  "investor_067":"第一届第六次",
  "investor_068":"第一届第七次",
  "investor_069":"第一届第八次",
  "investor_070":"第一届第九次",
  "investor_071":"第一届第十次",
  "investor_072":"第一届第十一次",
  "investor_073":"第一届第十二次",
  "investor_074":"第一届第十三次",
  "investor_075":"第一届第十四次",
  "investor_076":"第一届第十五次",
  "investor_077":"第一届第十六次",
  "investor_078":"第一届第十七次",

  "investor_079":"110.01.29",
  "investor_080":"110.04.08",
  "investor_081":"110.05.13",
  "investor_082":"110.07.20",
  "investor_083":"110.08.10",
  "investor_084":"110.09.17",
  "investor_085":"110.11.10",
  "investor_086":"111.01.24",
  "investor_087":"111.03.22",
  "investor_088":"111.05.04",
  "investor_089":"111.08.09",
  "investor_090":"111.10.07",
  "investor_091":"111.11.10",

  "investor_092":"1.本公司为扩充梁社汉排骨生产线，拟购置新厂房",
  "investor_093":"2.本公司财务报告编制能力之自行评估案",
  "investor_094":"3.拟订定本公司「公司治理实务守则」",
  "investor_095":"4.拟订定本公司「诚信经营守则」及「诚信经营作业程序及行为指南」",
  "investor_096":"5.拟订定本公司「企业社会责任守则」",
  "investor_097":"6.拟订定本公司「道德行为准则」",
  "investor_098":"7.拟订定本公司「处理董事要求之标准作业程序」",
  "investor_099":"除第1案因管理阶层另有规划而先行撤案，于日后若有其他购置计划时再行提案外，其他议案业经四位独立董事均同意通过。",
  "investor_100":"1.本公司109年度决算表册案",
  "investor_101":"2.本公司109年度盈余分配案",
  "investor_102":"3.出具本公司之「内部控制制度声明书」案",
  "investor_103":"4.为配合本公司股票初次上市前办理现金增资发行新股事宜，拟请原股东全数放弃优先认购权利",
  "investor_104":"5.110年度会计师公费暨独立性评估审核案",
  "investor_105":"6.本公司拟对子公司钫鑫国际贸易股份有限公司资金贷与新台币3,000万元额度案",
  "investor_106":"7.拟修订本公司「股东会议事规则」案",
  "investor_107":"8.拟订本公司「董事会绩效评估办法」案",
  "investor_108":"9.拟修订本公司「董事会议事规范」案",
  "investor_109":"10.拟修订本公司「董事选任程序」案",
  "investor_110":"11.拟修订本公司「薪资报酬委员会组织规程」案",
  "investor_111":"12.拟修订本公司「独立董事之职责范畴规则」案",
  "investor_112":"1.通过本公司110年第1季合并财务报表案",
  "investor_113":"1.拟办理现金增资发行新股作为本公司股票上市前公开承销股份案",
  "investor_114":"1.拟通过本公司110年第2季合并财务报表案",
  "investor_115":"2.拟通过110年上半年度盈余分配案",
  "investor_116":"1.拟承租土地及建物案",
  "investor_117":"2.拟进行淡水三厂扩厂计划案",
  "investor_118":"1.拟通过本公司110年第3季合并财务报表案",
  "investor_119":"2.本公司拟与统一综合证券股份有限公司进行保本票据(Principal Guaranteed Note, PGN)交易案",
  "investor_120":"3.本公司财务长任免及代理发言人异动案",
  "investor_121":"4.拟订定本公司111年度稽核计划案",
  "investor_122":"5.拟对子公司丹堤咖啡食品股份有限公司资金贷与新台币5,000万元额度案",
  "investor_123":"1.本公司新北市淡水区屯山段淡水三厂预算追加及扩建案",
  "investor_124":"2.本公司拟对子公司八方云集餐饮股份有限公司资金贷与新台币一亿元额度案",
  "investor_125":"3.本公司拟对子公司丹堤咖啡食品股份有限公司办理背书保证案",
  "investor_126":"4.拟增资100%转投资Bafang Yunji International (USA) Limited及持股60%之Bafang Yunji Foods LLC案",
  "investor_127":"5.发放经理人110年度年终奖金案",
  "investor_128":"6.本公司更换签证会计师案",
  "investor_129":"7.拟修订本公司「财务报表编制流程管理办法」",
  "investor_130":"8.拟修订本公司「公司治理实务守则」",
  "investor_131":"9.拟修订本公司「防范内线交易管理办法」",
  "investor_132":"10.拟修订本公司「核决权限表」",
  "investor_133":"1.拟通过本公司110年度决算表册案",
  "investor_134":"2.拟通过110年度盈余分配案",
  "investor_135":"3.本公司拟兴建大林厂计划案",
  "investor_136":"4.出具本公司之「内部控制制度声明书」案",
  "investor_137":"5.111年度会计师公费暨独立性评估审核案",
  "investor_138":"6.拟修订本公司「取得或处分资产处理程序」案",
  "investor_139":"7.拟修订本公司「内部稽核实施细则」案",
  "investor_140":"8.拟修订美国子公司之稽核计划案",
  "investor_141":"9.拟修订本公司「股东会议事规则」案",
  "investor_142":"1.拟通过本公司2022年第1季合并财务报表案",
  "investor_143":"2.拟修订本公司「企业社会责任实务守则」案",
  "investor_144":"3.本公司拟向子公司提前解除租约案",
  "investor_145":"1.拟通过本公司111年第2季合并财务报表案",
  "investor_146":"2.111年上半年度盈余分配案",
  "investor_147":"3.本公司拟向子公司Bafang Yunji (Samoa) International Co., Ltd.购买八方云集国际集团有限公司股权案",
  "investor_148":"4.子公司Bafang Yunji (Samoa) International Co., Ltd.拟办理减资案",
  "investor_149":"5.拟注销子公司Bafang Yunji (Samoa) Investment Company Limited案",
  "investor_150":"6.本公司2022年度对「财团法人新北市私立八方云集社会福利慈善事业基金会」捐赠新台币三百万元案",
  "investor_151":"1.拟增资子公司Bafang Yunji International (USA) Limited及再转增资子公司Bafang Yunji Foods LLC及子公司Bafang Yunji Restaurant Group LLC案",
  "investor_152":"2.本公司拟于屯山厂增设冷冻调理包生产线案",
  "investor_153":"3.福建八方云集食品有限公司及福建八方云集餐饮管理有限公司结束营业案",
  "investor_154":"1.本公司更换签证会计师案",
  "investor_155":"2.拟通过本公司111年第3季合并财务报表案",
  "investor_156":"3.拟订定本公司「风险管理政策与程序」案",
  "investor_157":"4.拟订定本公司「永续报告书编制及验证之作业程序」案",
  "investor_158":"5.拟修订本公司内部控制制度「计算机化信息系统」案",
  "investor_159":"6.拟订定本公司「内部重大信息处理作业程序」",
  "investor_160":"7.拟修订本公司「董事会议事规范」案",
  "investor_161":"8.拟订定本公司112年度稽核计划案",
  "investor_162":"无",
  "investor_163":"全体出席委员同意通过",
  "investor_164":"全体出席董事同意通过",
  "investor_165":"(二)除前开事项外，其他未经审计委员会通过，而经全体董事三分之二以上同意之议决事项：无此情事。",
  "investor_166":"(三)独立董事对利害关系议案回避之执行情形，应叙明独立董事姓名、议案内容、应利益回避原因以及参与表决情形：无此情事。",
  "investor_167":"会计师独立性及适任性评估",
  "investor_167-1":"独立性",
  "investor_167-2":"适任性",
  "investor_168":"评估内容",
  "investor_169":"项次",
  "investor_170":"否",
  "investor_171-1":"1",
  "investor_172-1":"2",
  "investor_173-1":"3",
  "investor_174-1":"4",
  "investor_175-1":"5",
  "investor_176-1":"6",
  "investor_177-1":"7",
  "investor_178-1":"8",
  "investor_179-1":"9",
  "investor_180-1":"10",
  "investor_1811-1":"11",
  "investor_171":"会计师无与本公司有直接或重大间接财务利益关系。",
  "investor_172":"会计师无与本公司或本公司董事有融资或保证行为。",
  "investor_173":"会计师无与本公司有重大密切之商业关系及潜在之雇佣关系。",
  "investor_174":"会计师及审计小组成员目前或最近二年无担任本公司之董事、经理人或对审计案件有重大影响之职务。",
  "investor_175":"会计师对公司所提供之非审计服务无直接影响审计案件之重要项目。",
  "investor_176":"会计师无宣传或中介本公司所发行之股票或其他证券。",
  "investor_177":"会计师除依法令许可之业务外，无代表本公司与第三者间法律案件或其他争议事项之辩护。",
  "investor_178":"会计师无与本公司之董事、经理人或对审计案件有重大影响职务之人员有亲属关系。",
  "investor_179":"卸任一年以内之共同执业会计师并无担任本公司董事、经理人或对查核案件有重大影响之职务。",
  "investor_180":"会计师无收受本公司或其董事、经理人或主要股东价值重大之礼物馈赠或特别优惠。",
  "investor_181":"是",
  "investor_1811":"会计师任期无连续超过七年。",
  "investor_1711":"会计师最近二年无会计师惩戒委员会惩戒纪录。",
  "investor_1722":"会计师事务所在处理公司审计服务上是否有足够的规模、资源及区域覆盖率?",
  "investor_1733":"会计师事务所是否有明确的质量控管程序，以确保财务报告之质量？",
  "investor_1744":"会计师事务所在风险管理、公司治理、财务会计及相关风险控制上是否及时通知董事会(审计委员会)任何显著的问题及发展？",
  "investor_182":"薪资报酬委员会运作情形信息",
  "investor_183":"1.薪酬委员会职责",
  "investor_184":"● 本公司自109年7月7日起正式设置薪资报酬委员会，主要职权如下：",
  "investor_185":"委员会以善良管理人之注意，忠实履行下列职权，并将所提建议提交董事会讨论：",
  "investor_186":"一、定期检讨规程并提出修正建议。",
  "investor_187":"二、订定并定期检讨本公司董事及经理人绩效评估标准、年度及长期之绩效目标，与薪资报酬之政策、制度、标准与结构，并于年报中揭露绩效评估标准之内容。",
  "investor_188":"三、定期评估本公司董事及经理人之绩效目标达成情形，并依据绩效评估标准所得之评估结果，订定其个别薪资报酬之内容及数额。年报中应揭露董事及经理人之个别绩效评估结果，及个别薪资报酬之内容及数额与绩效评估结果之关联性及合理性，并于股东会报告。",
  "investor_189":"",//留空
  "investor_190":"2.薪资报酬委员会运作情形",
  "investor_191":"● 本公司之薪资报酬委员会于109年07月07日成立，委员计4人，本届委员任期：112年06月15日至115年06月14日，截至112年12月31日，已开会1次，委员出列席情形如下：",
  "investor_192":"",//留空
  "investor_193":"召集人",
  "investor_194":"委员",
  "investor_195":"其他应记载事项：",
  "investor_196":"一、董事会如不采纳或修正薪资报酬委员会之建议，应叙明董事会日期、期别、议案内容、董事会决议结果以及公司对薪资报酬委员会意见之处理:无此情事。",
  "investor_197":"二、薪资报酬委员会之议决事项，如成员有反对或保留意见且有纪录或书面声明者，应叙明薪资报酬委员会日期、期别、议案内容、所有成员意见及对成员意见之处理",
  "investor_198":"第一届第二次",
  "investor_199":"第一届第三次",
  "investor_200":"第一届第四次",
  "investor_201":"110.01.29",
  "investor_202":"110.04.08",
  "investor_203":"110.07.20",
  "investor_204":"110.08.10",
  "investor_205":"110.11.10",
  "investor_206":"111.01.24",
  "investor_207":"111.03.22",
  "investor_208":"111.08.09",
  "investor_209":"111.10.07",
  "investor_210":"111.11.10",
  "investor_211":"发放经理人109年度年终奖金",
  "investor_212":"109年度员工酬劳及董事酬劳分配案",
  "investor_213":"1.订定110年度现金增资员工认股办法",
  "investor_214":"2.经理人于110年度现金增资员工认股情形",
  "investor_215":"3.修订员工酬劳实施办法",
  "investor_216":"本公司109年度员工酬劳发放案",
  "investor_217":"本公司109年度员工酬劳发放修正案",
  "investor_218":"发放经理人110年度年终奖金",
  "investor_219":"110年度员工酬劳及董事酬劳分配案",
  "investor_220":"本公司110年度员工酬劳发放案",
  "investor_221":"本公司经理人调整薪资报酬案",
  "investor_222":"评估检讨董事及经理人薪资报酬之政策、制度、标准与结构",
  "investor_223":"委员会决议结果",
  "investor_224":"公司对薪酬委员会意见之处理",
  "investor_225":"本公司风险管理组织架构包含董事会、风险管理委员会、稽核室与各单位。",
  "investor_226":"风险管理组织",
  "investor_227":"职责",
  "investor_228":"董事会为风险管理之最高治理单位，负责公司整体风险之最终责任。",
  "investor_229":"风险管理委员会",
  "investor_230":"风险管理委员会直接隶属董事会，由7位董事组成，其中过半数为独立董事。负责进行风险管理相关运作机制之监督，并定期(每年至少1次)向董事会报告风险管理执行情形。该委员会过半数成员由独立董事担任，并由独立董事担任主席。",
  "investor_2301":"第一届风险管理委员会委员 (任期：112年6月23日-115年6月14日)",
  "investor_2311":"风险管理委员会职权如下：",
  "investor_231":"(1)	审查风险管理政策、程序与架构，并定期检讨其适用性与执行效能；",
  "investor_232":"(2)	核定风险胃纳(风险容忍度)，导引资源分配；",
  "investor_233":"(3)	确保风险管理机制能充分处理公司所面临之风险，并融合至日常营运作业流程中",
  "investor_234":"(4)	核定风险控管的优先级与风险等级；",
  "investor_235":"(5)	审查风险管理执行情形，提出必要之改善建议，并定期向董事会报告；",
  "investor_236":"(6)	执行董事会之风险管理决策。",
  "investor_237":"稽核室",
  "investor_238":"稽核室依风险评估结果拟定年度计划，内部控制体系部分，由稽核室评估个单位执行有关风险管理作业是否落实执行，确认各项作业风险均获得有效管控，并适时提出改善建议。",
  "investor_239":"风险管理推动与执行小组",
  "investor_240":"以任务编组方式成立风险管理推动与执行小组，执行风险管理委员会之风险管理决策，负责规划、执行与监督风险管理相关事务，并协助推动企业风险管理文化。风险管理推动与执行小组由总经理任命总管理处主管兼任，小组成员由本公司各单位相关主管组成，并定期向风险管理委员会提报公司风险管理执行情形报告。",
  "investor_241":"各单位",
  "investor_242":"各单位主管负有风险管理之责任，负责风险辨识、分析及监控所属单位内之相关风险，确保风险管理机制与程序能有效执行。",
  "investor_243":"风险管理政策与程序",
  "investor_244":"本公司为持续强化公司治理并健全风险管理作业，董事会于2022年11月10日通过「风险管理政策与程序」，作为本公司风险管理之最高指导原则。本政策涵盖管理目的、风险范围、组织架构与职责、管理程序、风险类型、风险管理之运作与执行落实之评估，将业务活动所产生的风险控制在可接受的范围，以合理确保公司目标之达成与企业永续经营与发展。",
  "investor_245":"风险管理的范畴",
  "investor_246":"本公司的风险管理范畴包括「策略与经营风险」、「市场风险」、「食安风险」、「信息风险」、「法遵风险」、「财务风险」、「环境风险」、以及凡与本公司产品及生产、服务的过程有关的活动等之风险管理皆涵盖。",
  "investor_247":"风险管理运作与执行情形",
  "investor_248":"112年11月9日由风险管理推动与执行小组向风险管理委员会报告有关规划与执行风险管理相关事务，并于同年12月20日于董事会提出风险管理执行情形报告。本公司面对各层面可能之风险，已订定相关管理政策，且持续透过内部管理会议及不定期针对特定事件检讨，让风险发生的可能性及影响降到最低。",
  "investor_249":"设置公司治理主管",
  "investor_250":"本公司2023年6月23日于董事会决议设置公司治理主管，現由公司治理室郑秋治协理担任，其办理薪酬委员会相关事务已达三年以上，符合于证券、金融、期货相关机构或公开发行公司从事法务、财务、法令遵循、内部稽核、股务或第21条所定公司治理相关事务单位之主管职务达三年以上之规范。",
  "investor_251":"相关学经历及2023年度进修信息如下：",
  "investor_252":"郑秋治 总管理处协理",
  "investor_253":"学历：元智大学企研所",
  "investor_254":"经历：",
  "investor_255":"八方云集国际股份有限公司总管理处 协理",
  "investor_256":"人力资源部、总经理室、营销企划部、公关客服部 经理",
  "investor_257":"业务直营部、业务训练部 副理",
  "investor_258":"序号",
  "investor_259":"主办单位",
  "investor_260":"课程名称",
  "investor_261":"进修期间",
  "investor_262":"进修时数",
  "investor_263":"当年度进修总时数",
  "investor_264":"起",
  "investor_265":"迄",
  "investor_266":"财团法人中华民国证券暨期货市场发展基金会",
  "investor_267":"社团法人中华公司治理协会",
  "investor_268":"财团法人中华民国证券暨期货市场发展基金会",
  "investor_269":"社团法人中华公司治理协会",
  "investor_270":"社团法人中华公司治理协会",
  "investor_271":"社团法人中华公司治理协会",
  "investor_272":"台湾证券交易所、证券柜台买卖中心",
  "investor_273":"台湾证券交易所",
  "investor_274":"112年度内部人股权交易法律遵循倡导说明会",
  "investor_275":"企业经营及舆论新闻危机管理策略",
  "investor_276":"112年度防范内线交易倡导会",
  "investor_277":"从案例介绍经营权争夺下的董事会及股东会程序争议",
  "investor_278":"董事会绩效评估实务分享研讨会",
  "investor_279":"经营权与董事责任研讨会",
  "investor_280":"2023年上市柜公司永续发展行动方案倡导会",
  "investor_281":"2023国泰永续金融暨气候变迁高峰论坛",
  "investor_282":"112/11/22",
  "investor_283":"112/11/09",
  "investor_284":"112/10/13",
  "investor_285":"112/08/10",
  "investor_286":"112/07/26",
  "investor_287":"112/07/20",
  "investor_288":"112/07/04",
  "investor_289":"3小时",
  "investor_290":"6小时",
  "investor_291":"27小时",
  "investor_292":"公司治理运作情形",
  "investor_293":"公司治理运作情形即与上市上柜公司治理实务守则差异情形及原因",
  "investor_294":"评估项目",
  "investor_295":"运作情形",
  "investor_296":"与上市上柜公司治理实务守则差异情形及原因",
  "investor_297":"是",
  "investor_298":"否",
  "investor_299":"摘要说明",
  "investor_300":"一、公司是否依据「上市上柜公司治理实务守则」订定并揭露公司治理实务守则？",
  "investor_301":"为建立本公司良好之公司治理制度，已参酌「上市上柜公司治理实务守则」订定本公司之「公司治理实务守则」，于110年1月29日董事会通过，并配合法令，于111年1月24日及112年1月17日董事会通过修订「公司治理实务守则」，于公开观测信息站与本公司网站揭露。",
  "investor_302":"与治理实务守则之原则无重大差异。",
  "investor_303":"二、公司股权结构及股东权益",
  "investor_304":"(一)公司是否订定内部作业程序处理股东建议、疑义、纠纷及诉讼事宜，并依程序实施？",
  "investor_305":"(二)公司是否掌握实际控制公司之主要股东及主要股东之最终控制者名单？",
  "investor_306":"(三)公司是否建立、执行与关系企业间之风险控管及防火墙机制？",
  "investor_307":"(四)公司是否订定内部规范，禁止公司内部人利用市场上未公开信息买卖有价证券？",
  "investor_308":"本公司为确保股东权益，订定「股东会议事规则」，设有发言人、代理发言人及股务信箱外，本公司亦委托专业股务代理机构「中国信托商业银行股份有限公司」代理部处理股东之相关问题及建议，若涉及法律问题，则将委请专业律师或法务人员进行处理。",
  "investor_309":"本公司设有股务人员管理相关信息，并委任专责股务代理机构协助处理股务相关事宜，掌握实际控制公司之主要股东及主要股东之最终控制者名单。",
  "investor_310":"本公司与各子公司间之财务、业务均独立运作，并受本公司控管与稽核。本公司订有「关系人交易管理办法」，与关系企业经营、业务及财务往來皆有明确规范，已达风险控管机制。",
  "investor_311":"本公司已订定「防范内线交易管理办法」规范。本公司并一年至少一次以上进行教育训练，提醒内部人有关内线交易之相关规范。",
  "investor_312":"无重大差异",
  "investor_313":"三、董事会之组成及职责",
  "investor_314":"(一)董事会是否拟订多元化政策、具体管理目标及落实执行？",
  "investor_315":"(二)公司除依法设置薪资报酬委员会及审计委员会外，是否自愿设置其他各类功能性委员会？",
  "investor_316":"(三)公司是否订定董事会绩效评估办法及其评估方式，每年并定期进行绩效评估，且将绩效评估之结果提报董事会，并运用于个别董事薪资报酬及提名续任之参考？",
  "investor_317":"(四)公司是否定期评估签证会计师独立性？",
  "investor_318":"本公司「董事选任程序」中明订董事会成员组成应考量多元化，就本身运作、营运型态及发展需求來作整体配置，包括但不限于性别、年龄、国籍、文化及专业知識技能。本公司第四届董事会依据公司章程设置9席董事(现有8席，其中含2席女性董事)，且董事会成员各自拥有不同商务、法务、财务、科技及产业等相关专业经验背景，董事组成具有多元化且符合公司发展需求。",
  "investor_319":"本公司除设置薪资报酬委员会及审计委员会外，将视需要评估设置其他各类功能性委员会。",
  "investor_320":"本公司已订定「董事会绩效评估办法」，以落实公司治理并提升本公司董事会功能，建立绩效目标以加强董事会运作效率。111年度之绩效评估结果已于112年第一季完成，并提报112年3月23日董事会。",
  "investor_321":"依据本公司公司治理实务守则第29条规定，每年应定期(至少一年一次)评估聘任会计师之独立性及适任性，本公司除要求签证会计师提供「独立性声明」及「审计质量指针AQIs」，并参考AQI 报告内容包括专业性、质量控管、独立性、监督、创新能力等 5 大构面及 13 项指标及附表一标准进行评估。最近一年度评估结果业经112年3月23日董事会决议通过，均符合本公司独立性及适任性评估标准。",
  "investor_322":"四、上市上柜公司是否配置适任及适当人数之公司治理人员，并指定公司治理主管，负责公司治理相关事务(包括但不限于提供董事、监察人执行业务所需数据、协助董事、监察人遵循法令、依法办理董事会及股东会之会议相关事宜、制作董事会及股东会议事录等)？",
  "investor_323":"五、公司是否建立与利害关系人(包括但不限于股东、员工、客户及供货商等)沟通管道，及于公司网站设置利害关系人专区，并妥适响应利害关系人所关切之重要企业社会责任议题？",
  "investor_324":"六、公司是否委任专业股务代办机构办理股东会事务？",
  "investor_325":"本公司已设置专人负责提供董事、审计委员会委员执行业务所需数据、协助董事、审计委员会委员遵循法令、依法办理董事会及股东会之会议相关事宜、制作董事会及股东会议事录等。",
  "investor_326":"本公司设有发言人及代理发言人，作为利害关系人沟通管道，并于本公司官网及公开信息观测站上均设有聯络方式及信箱，可以提供给利害关系人随时聯系。",
  "investor_327":"本公司已委托中国信托代理部代办机构办理股东会及相关事务。",
  "investor_328":"七、信息公开",
  "investor_329":"(一)公司是否架设网站，揭露财务业务及公司治理信息？",
  "investor_330":"(二)公司是否实行其他信息揭露之方式（如架设英文网站、指定专人负责公司信息之搜集及揭露、落实发言人制度、法人说明会过程放置公司网站等）？",
  "investor_331":"(三)公司是否于会计年度终了后两个月内公告并申报年度财务报告，及于规定期限前提早公告并申报第一、二、三季财务报告与各月份营运情形？",
  "investor_332":"本公司已架设企业网站揭露财务业务及公司治理等相关信息，并由专人负责，并透过与公开信息观测站链接，以利信息实时更新及揭露。",
  "investor_333":"本公司设有专人负责信息之搜集及揭露，并已设置发言人及代理发言人制度，并将法人说明会过程放置公司网站。",
  "investor_334":"本公司依规定于期限内公告并申报年度财务报告，第一、二、三季财务报告与各月份营运情形。",
  "investor_335":"未来视需要评估提前公告及申报",
  "investor_336":"八、公司是否有其他有助于了解公司治理运作情形之重要信息(包括但不限于员工权益、雇员关怀、投资者关系、供货商关系、利害关系人之权利、董事及监察人进修之情形、风险管理政策及风险衡量标准之执行情形、客户政策之执行情形、公司为董事及监察人购买责任保险之情形等)？",
  "investor_337":"(一)员工权益：成立职工福利委员会、实施退休金、投保员工团体保险等措施。",
  "investor_338":"(二)雇员关怀：除依相关法令办理外，另提供同仁结婚补助、同仁子女结婚礼金、同仁生育奖励金、子女教养补助、同仁暨眷属丧葬给付等福利。依规成立职工福利委员会，提拨福利金，办理如员工旅游暨健康检查补助、生日礼金、医疗急难救助贷款等员工福利事务。",
  "investor_339":"(三)投资者关系：依相关法令规定揭露财务业务、重大讯息等信息于公开信息观测站，供投资人了解，并建立发言人制度妥善处理投资人各项询问，维持与投资者良好关系。",
  "investor_340":"(四)供货商关系：本公司依平等互惠原则与供货商建立伙伴关系，且不定期进行稽核，建立食品安全供应链。",
  "investor_341":"(五)利害关系人之权利：揭露财务业务、重大讯息等信息于公开信息观测站，供利害关系人了解。",
  "investor_342":"(六)董事进修之情形：本公司董事均具有专业背景，且本公司以积极之态度安排董事参与进修，111年度已针对董事办理课程，请参阅以下附表二。",
  "investor_343":"(七)风险管理政策及风险衡量标准之执行情形：本公司董事会已于111年通过「风险管理政策与程序」，对于风险管理已依相关规范建立适当之政策、程序及内部控制，重要财务活动需经董事会依相关规范及内部控制制度进行复核。",
  "investor_344":"(八)客户政策之执行情形：秉持消费者至上之经营理念，坚持提供「安全、新鲜、美味、平价」之产品。",
  "investor_345":"(九)公司为董事及经理人购买责任保险之情形：本公司已于111年8月6日为董事及经理人进行投保。",
  "investor_346":"(十)董事会成员及重要管理阶层之接班计划：本公司「公司章程」中载明定董事选举应采候选人提名制度，并订有「公司治理实务守则」及「董事选任程序」，明订董事会成员组成应考量多元化，并就公司本身运作、营运型态及发展需求以拟订适当之多元化方针，宜包括但不限于基本条件与价值、专业知識技能等兩大面向之标准。",
  "investor_347":"目前董事设置9名(现任8名，包含4名独立董事)，具备多元互补之产业经验及金融、财务、会计、法律及信息等专业能力。现任董事成员中1人兼任本公司高阶管理阶层。",
  "investor_348":"关于董事会之接班规划，本公司培育高阶经理人进入董事会，使其熟悉董事会运作及公司各单位业务，并透过工作輪调方式深化其产业经验。目前公司尚有多位高阶管理人才，具充沛之人才库可以选任为未來之董事。除考量多元化，兼任公司经理人之董事不逾董事席次三分之一，并将注重性别平等，具备执行职务所必须之知識、技能及素养。",
  "investor_349":"重要管理阶层",
  "investor_350":"1.接班计划：本公司自111年起每年检视公司重要管理职位的接班人才库状况，并依据检视成果，规划各团队的培养计划。",
  "investor_351":"2.运作情形：自111年起，每年各单位最高主管皆针对其单位中的重要管理职位的接班人才状况做全盘检视及规划。担任重要管理职位人员，需对其所属职能拟定接班人，无接班人者提出锻炼内部合适之接班人选，或寻找外部人才加入公司等规划。并需针对预计接班人升迁到管理阶层的潜力进行评估，并搭配合适之培训计划及教育训练，针对管理职能进行培育并历练项目计划之执行。",
  "investor_352":"总经理是本公司营运发展最关键的人物，必须对公司及产业都具有长期经验且了解市场脉动，方能进行完整规划并带领公司发展。现任总经理张瑞莲女士，自民国98年加入本公司，先后担任财务长及执行副总，带领公司财务、营运及业务发展等相关事务，于106年2月晋升总经理。",
  "investor_353":"九、请就台湾证券交易所股份有限公司公司治理中心最近年度发布之公司治理评鉴结果说明已改善情形，及就尚未改善者提出优先加强事项与措施。(未列入受评公司者无需填列)：",
  "investor_354":"本公司111年首度参与「公司治理评鉴」，针对治理评鉴结果预计改善加强事项说明如下：",
  "investor_355":"(一)维护股东权益及平等对待股东：",
  "investor_356":"1.过半数董事会及审计委员会召集人亲自出席股东常会：将积极协调董事、独立董事出席股东常会。",
  "investor_357":"(二)强化董事会结构与运作：",
  "investor_358":"1.公司已于111年11月10日通过本公司「风险管理政策与程序」，并预定于112年设置「风险管理委员会」及公司治理主管。",
  "investor_359":"2.本公司已针对重要管理阶层之接班规划，盘点具潜力之接班人，拟定个人发展规划并予以培训。",
  "investor_360":"(三)提升信息透明度：",
  "investor_361":"1.自112年起同步申报英文重大讯息。",
  "investor_362":"2.112年底前完成英文网站建置。",
  "investor_363":"(四)落实企业责任：",
  "investor_364":"1.已设置推动诚信经营之单位，并于112年安排向董事会报告。",
  "investor_365":"(2)会计师与独立董事之沟通",
  "investor_366":"112年会计师除参与各季与财务报表议案相关之审计委员会及董事会报告查核或核阅结果外，已分别于3月23日及11月9日与审计委员会进行单独的沟通讨论。",
  "investor_367":"112/03/23",
  "investor_368":"112/11/09",
  "investor_369":"勤业众信 会计师李丽凰",
  "investor_370":"勤业众信 协理黄咸琛",
  "investor_371":"出席人员",
  "investor_372":"沟通事项",
  "investor_373":"沟通结果",
  "investor_374":"勤业众信 会计师郭乃华",
  "investor_375":"沟通报告111年度财务报告最终查核范围、查核的调整、关键查核事项、与管理阶层讨论之重大事项及查核结论等查核结论事项",
  "investor_376":"沟通112年度财务报告查核目标、查核范围、查核程序等查核规划事项",
  "investor_377":"结论：就111年度财务报告查核结论事项无异议。",
  "investor_378":"结论:就 112年度财务报告查核规划事项无异议。",
  "investor_379":"",
  "investor_380":"",
  "investor_381":"",
  "investor_382":"",
  "investor_383":"",
  "investor_384":"",
  "investor_385":"",
  "investor_386":"",
  "investor_387":"无异议照案通过",
  "investor_388":"落实诚信经营",
  "investor_389":"",//留空
  "investor_390":"本公司已订定「诚信经营守则」及「诚信经营作业程序及行为指南」并经董事会通过，作为公司诚信经营之政策及作业指导原则。「诚信经营作业程序及行为指南」中，已辨识营业范围中较可能发生不诚信行为风险之营业活动，并已订定相关作业规则「诚信违反检举作业办法」。另本公司工作规则明订员工应本着「诚、正、信、实」的工作态度善尽职责，严禁直接或间接提供、承诺、要求或收受任何不正当利益，或做出其他违反诚信、不法或违背受托义务之不诚信行为。",
  "investor_391":"诚信经营之倡导",
  "investor_392":"本公司透过定期经理月会进行各项倡导(含营运及诚信经营层面、食品安全卫生管理等相关内容)。此外，本公司亦订有诚信经营相关办法，并每年度定期向同仁倡导诚信原则以提升法律遵循意识，降低不诚信行为之风险。",
  "investor_393":"诚信经营专责单位",
  "investor_394":"本公司设置隶属于董事会之企业诚信经营专责单位为总经理室法务主管，办理企业诚信经营作业程序及其行为指南之修订、执行、解释、咨询服务暨通报内容登录建文件等相关作业及监督执行，并于112/11/9已向董事会报告。",
  "investor_395":"履行诚信经营情形及实行措施",
  "investor_396":"履行诚信经营情形及与上市上柜公司诚信经营守则差异情形及原因",
  "investor_397":"2023年度教育训练",
  "investor_398":"● 4月11日、5月22日及24日对国际员工举办「诚信经营守则概述及检举制度」说明会，含倡导并请与会者签署声明文件。(协理级以上19人，一般同仁39名签署)",
  "investor_399":"● 5月16日、6月19日针对餐饮(门市)员工举办「诚信与从业道德及内部检举制度」说明会。",
  "investor_400":"● 10月11日对国际员工举办「禁止内线交易倡导说明」。(上一年度为2022年12月13日)",
  "investor_401":"萧玉娟",
  "investor_402":"第二届第一次",
  "investor_403":"112.01.17",
  "investor_404":"112.03.23",
  "investor_405":"112.08.10",
  "investor_406":"发放经理人111年度年终奖金",
  "investor_407":"1.111年度员工酬劳及董事酬劳分配案",
  "investor_408":"2.本公司晋升经理人暨调整薪资报酬案",
  "investor_409":"1.111年度员工酬劳发放案",
  "investor_410":"2.本公司晋升经理人及调整经理人薪资报酬案",
  "investor_411":"",
  "investor_412":"",
  "investor_413":"",
  "investor_414":"",
  "investor_415":"",

  "investor_416":"本公司已订定「诚信经营守则」及「诚信经营作业程序及行为指南」 并经董事会通过，作为公司诚信经营之政策及作业指导原则。",
  "investor_417":"本公司于「诚信经营作业程序及行为指南」中，已辨识营业范围中较可能发生不诚信行为风险之营业活动，并已订定相关作业规则。另本公司工作规则明订员工应本着「诚、正、信、实」的工作态度善尽职责，严禁直接或间接提供、承诺、要求或收受任何不正当利益，或做出其他违反诚信、不法或违背受托义务之不诚信行为。",
  "investor_418":"本公司已订定「诚信经营守则」及「诚信经营作业程序及行为指南」，明订防范不诚信行为相关制度与程序。本公司全体九席董事及公司经理人(协理级以上)皆已签署诚信声明书，落实诚信经营方针。另公司为加强倡导诚信原则，除于公司的官网内明示本公司企业精神之内涵，111年对八方云集总公司(含餐饮子公司、丹堤子公司)公司员工进行：(1)诚信经营、(2)资通安全、(3)防范内线交易及(4)食品安全方面的教育训练，总训练人次共746人次，总训练时数共855小时，以期提升同仁品德观念，建立良好的企业文化，并以相同的水平要求往来之供货商、客户。",
  "investor_419":"本公司诚信经营守则已具体规范本公司人员，于从事商业行为之过程中，不得直接或间接提供、承诺、要求或收受任何不正当利益，或做出其他违反诚信、不法或违背受托义务之行为。另于往来供货商合约亦明载诚信声明书及违反诚信之相关处理方式。",
  "investor_420":"本公司设置隶属于董事会之企业诚信经营专责单位为总经理室法务主管，办理企业诚信经营作业程序及其行为指南之修订、执行、解释、咨询服务暨通报内容登录建文件等相关作业及监督执行，并定期向董事会报告。",
  "investor_421":"本公司董事、经理人及其他出席或列席董事会之利害关系人对董事会所列议案，与其自身或其代表之法人有利害关系者，应于当次董事会说明其利害关系之重要内容，如有害于公司利益之虞时，不得加入讨论及表决，且讨论及表决时应予回避，并不得代理其他董事行使其表决权。",
  "investor_422":"本公司为确保诚信经营之落实，订有「诚信经营守则」及「诚信经营作业程序及行为指南」以兹遵循，防范不诚信行为发生，并建立有效之会计制度及内部控制制度，公司内部稽核单位定期查核各项制度遵循情形，并作成稽核报告提报董事会。",
  "investor_423":"本公司定期对员工举办诚信经营教育训练与倡导，董事长、总经理或高阶管理阶层亦不定期向员工传达诚信之重要性，使其充分了解公司诚信经营之决心、政策、防范方案及实施不诚信行为之后果。",
  "investor_424":"本公司接受任何不法或不道德情事之通报，设有专门信箱，直接由法务主管受理，并对检举人身分及检举内容确实保密。",
  "investor_425":"本公司对检举人之身分及检举内容保密，并保护检举人不因检举而遭受不当处置之措施。",
  "investor_426":"本公司已订定「诚信经营守则」、「诚信经营作业程序及行为指南」及「诚信违反检举作业办法」，并揭露于公司网站及公开信息观测站。本公司并于股东会年报及网站揭露诚信经营执行情形。",
  "investor_427":"违反诚信检举窗口",
  "investor_428":"本公司对于建立诚信、透明的企业文化及促进健全经营等议题非常重视，如您发现本公司人员有违反诚信之事实时，可透过下列管道提出检举。",
  "investor_429":"检举方式及管道",
  "investor_430":"电子信箱：",
  "investor_431":"信件地址︰251新北市淡水区中正东路二段27号18楼 法务主管亲启",
  "investor_432":"检举人须知",
  "investor_433":"为加速案件之受理及调查，惠请检举人提供「检举函」所需内容或以该函径行提出供本公司查证。如有下列情形，本公司得不予受理。",
  "investor_434":"检举人未检附可供调查之具体事证。",
  "investor_435":"检举内容属恶意攻讦、虚伪不实或显无理由者。",
  "investor_436":"对检举人的保护",
  "investor_437":"本公司受理、调查及其他参与检举案件处理的人员，对于检举人的身分及检举案件的内容，均负有保密义务。",
  "investor_438":"本公司不因所属人员提出检举或协助他人检举而对其为不利对待或处分。惟检举案件经调查发现内容不实且涉及对本公司或本公司人员恶意攻讦者则不适用。",
  "investor_439":"检举窗体下载",
  "investor_440":"信息安全政策",
  "investor_441":"八方云集国际股份有限公司（以下简称本公司）为强化信息安全管理，确保信息的机密性、完整性与可用性、信息设备（包括计算机硬件、 软件、外围）与网络系统之可靠性以及同仁对信息安全之认知，并确保上述资源免受任何因素之干扰、破坏、入侵、或任何不利之行为与企图。",
  "investor_442":"信息安全组织",
  "investor_443":"依据金管会规范，本公司于112年正式成立资安室，且配置信息安全专责主管及一位信息安全专责人员，本公司为有效推动信息安全管理，明确规定本公司管理制度推动时组织之角色及职掌，使内部组织及内部控制达到优化，并彰显管理阶层对管理制度的重视及支持，进而使管理制度能持续并稳健的运作。为落实信息安全管理政策有效推动，本公司设置信息安全推动组，由总经理担任召集人，每月召开一次信息安全检讨会议及每年召开一次管理审查会议，就信息安全管理执行情形及信息安全相关事项进行研议，以提升整体资安防护能量。",
  "investor_444":"",
  "investor_445":"信息安全风险控制",
  "investor_446":"本公司积极的规划部署信息安全措施，不断改善信息安全环境，降低信息安全风险。管理上从政策制度、组织职责、人力安全、信息资产和风险管理、访问控制、实体环境、通讯安全、系统开发与维护、营运持续管理、供货商关系管理、法规遵循性等方面制订相关管理规范；技术上部署网络防火墙、应用程序防火墙、入侵防护系统、病毒防护系统等。每年有内部稽核人员对公司资安管理系统进行稽核，且针对资安运作状况、风险控制及事件改善等进行审查，并将审查结果呈报至信息安全推动组以控制资安风险。",
  "investor_447":"员工信息安全意识",
  "investor_448":"为了落实信息安全观念至每一位员工，本公司透过社交工程演练，仿真黑客的钓鱼邮件，检测员工资安风险意识，来提升同仁对于资安的意识及警觉性。",
  "investor_449":"本公司针对员工进行基本的信息安全教育训练。对在职人员通过定期的资安教育训练、影片倡导强化员工的资安意识。对内部信息安全稽核发现的问题，透过矫正预防流程实时进行信息安全管控，强化公司信息安全成熟度。",
  "investor_450":"灾难复原演练",
  "investor_451":"为确保营运与重要业务的永续运作，避免重要信息系统因重大灾难事件而导致服务无法持续的风险，本公司每年定期进行灾难复原演练，确保公司在关键时刻发挥灾难应变能力以灾害复原机制快速回复至企业正常或可接受的营运水平，以达到关键应用系统能持续运作并确保企业的营运不中断。",
  "investor_452":"本公司每年至少一次对董事、经理人及受雇人办理「防范内线交易管理作业程序」及内部重大讯息及相关法令之教育倡导。针对新任董事、经理人及受雇人适时提供教育倡导。",
  "investor_453":"本年度已于112年12月20日对现任董事进行教育倡导，课程内容包括内线交易法规及实务案例(共计9人次4.5小时)。",
  "investor_454":"112年10月11日对员工举办「禁止内线交易倡导」说明，(共计47人次15.6小时)。",
  "investor_455":"本公司以电子邮件提醒董事及相关内部人不得于年度财务报告公告前三十日，和每季财务报告公告前十五日之封闭期间，以及及重大消息公开后18小时内交易其股票。",
  "investor_456":"年度：",
  "investor_457":"(单位：新台币仟元)",
  "investor_458":"合并营收",
  "investor_459":"营收金额",
  "investor_460":"年度增减比率",
  "investor_461":"一月",
  "investor_462":"二月",
  "investor_463":"三月",
  "investor_464":"四月",
  "investor_465":"五月",
  "investor_466":"六月",
  "investor_467":"七月",
  "investor_468":"八月",
  "investor_469":"九月",
  "investor_470":"十月",
  "investor_471":"十一月",
  "investor_472":"十二月",
  "investor_473":"本年累计",
  "investor_474":"说明",
  "investor_475":"档案",
  "investor_476":"112年Q3合并财务报告",
  "investor_477":"112年Q2合并财务报告",
  "investor_478":"112年Q1合并财务报告",
  "investor_479":"111年度合并财务报告",
  "investor_480":"111年度个体财务报告",
  "investor_481":"111年Q3合并财务报告",
  "investor_482":"111年Q2合并财务报告",
  "investor_483":"111年Q1合并财务报告",
  "investor_484":"110年度合并财务报告",
  "investor_485":"110年度个体财务报告",
  "investor_486":"110年Q3合并财务报告",
  "investor_487":"110年Q2合并财务报告",
  "investor_488":"110年Q1合并财务报告",
  "investor_489":"109年Q2合并财务报告",
  "investor_490":"109年度合并财务报告",
  "investor_491":"109年度个体财务报告",
  "investor_492":"营益分析表",
  "investor_493":"财务分析资料",
  "investor_494":"*以上信息链接公开信息观测站*",
  "investor_495":"持股比例占前十名之股东、持数额及比例",
  "investor_496":"113年4月15日",
  "investor_497":"主要股东名称",
  "investor_498":"持有股数(股)",
  "investor_499":"持股比例(%)",
  "investor_500":"富御投资股份有限公司",
  "investor_501":"苏淑幸",
  "investor_502":"林宜娴",
  "investor_503":"林宜臻",
  "investor_504":"复兴资本有限合伙",
  "investor_505":"汇丰(台湾)商业银行股份有限公司受托保管ABS直接股权基金有限责任公司投资专户",
  "investor_506":"林御政",
  "investor_507":"刘旭钧",
  "investor_508-1":"吳敏哲",
  "investor_508":"股东会相关资料",
  "investor_509":"112年度",
  "investor_510":"111年度",
  "investor_511":"年报",
  "investor_512":"开会通知",
  "investor_513":"议事手册",
  "investor_514":"议事录",
  "investor_515":"110年度",
  "investor_516":"109年度",
  "investor_517":"*查询其他相关数据请至",
  "investor_518":"公开观测站",
  "investor_519":"，输入公司代号：2753*",
  "investor_520-1":"股利所属年(季)度：113年度",
  "investor_520":"股利所属年(季)度：112年度",
  "investor_521":"股利所属年(季)度：111年度",
  "investor_522":"股利所属年(季)度：110年度",
  "investor_523":"股利所属年(季)度：109年度",
  "investor_524":"以上信息链接公开信息观测站",
  "investor_525":"*查询历史数据请链接",
  "investor_526":"公开观测站",
  "investor_527":"，输入公司代号：2753",
  "investor_528":"",//留空
  "investor_529":"时间",
  "investor_530":"说明",
  "investor_531":"简报下载",
  "investor_5322":"2024-12-06",
  "investor_5321":"2024-05-15",
  "investor_532":"2023-12-06",
  "investor_533":"2023-03-29",
  "investor_534":"2022-11-22",
  "investor_535":"2022-09-13 ~ 09-15",
  "investor_536":"2022-08-17",
  "investor_537":"2021-08-12",
  "investor_5382":"受邀参加统一证券举办之2024Q4全球展望冬季投资论坛",
  "investor_5381":"受邀参加国泰证券举办之法人说明会",
  "investor_538":"受邀参加统一证券举办之2023Q4全球展望冬季投资论坛",
  "investor_539":"受邀参加元大证券举办之法人说明会",
  "investor_540":"受邀参加国泰证券举办之在线法人说明会",
  "investor_541":"受邀参加台湾董事学会、台湾证券交易所及安擘咨询共同举办之2022在线数字引资论坛",
  "investor_542":"受邀参加凯基证券举办之在线法人说明会",
  "investor_543":"上市前业绩发表会",
  "investor_544":"本公司盈余分派或亏损拨补于每半会计年度终了后为之，每半会计年度决算后如有盈余，应先提缴税款、弥补累积亏损，次提10%为法定盈余公积，但法定盈余公积累积已达本公司实收资本额时，得不再提列，其余再依法令或主管机关规定提拨或回转特别盈余公积，如尚有盈余，其余额再加计上半会计年度累计未分配盈余数，由董事会拟具分派议案。以发行新股方式为之时，应提请股东会决议后分派之；以现金方式为之时，应经董事会决议。",
  "investor_545":"本公司年度总决算如有盈余，应先提缴税款、弥补历年累积亏损，次提10%为法定盈余公积，但法定盈余公积已达本公司实收资本额时，得不再提列，其余再依法令或主管机关规定提拨或回转特别盈余公积，如尚有盈余，其余额再加计累计未分配盈余，由董事会拟具分派议案，以发行新股方式为之时，应提请股东会决议后分派之。",
  "investor_546":"本公司依公司法规定，授权董事会以三分之二以上董事之出席，及出席董事过半数之决议，将应分派股息及红利或公司法第二百四十一条第一项规定之法定盈余公积及资本公积之全部或一部，以发放现金之方式为之，并报告股东会。",
  "investor_547":"本公司处于企业成长阶段，股利政策系依据公司营运发展不同阶段、获利状况、公司中长期财务资本预算规划，并兼顾股东权益等因素，适度采股票股利或现金股利方式发放。每年就可供分配盈余提拨不低于20%作为股东股利，其中现金股利之比率不低于股利总数之20%。",
  "investor_548":"信息安全管理方针",
  "investor_549":"本公司于112年导入ISO 27001信息安全管理系统(Information Security Management System, ISMS)，并于同年9月正式取得国际验证机构SGS台湾检验科技公司的专业稽核团队验证。",
  "investor_550":"ISO 27001为检验ISMS的国际信息安全标准，通过标准验证，证明在资安制度、系统、运行及防御皆到达国际标准要求，本公司也持续积极地执行资安管控作业，落实P-D-C-A(Plan-Do-Check-Act)运作精神，以确保系统安全之机密性、完整性与可用性。",
  "investor_551":"证书是一个指标也是承诺，日后仍将定期执行信息安全的内部演练与教育训练，推动全体同仁重视资科保护，提升全员对于资安的意识和警觉，使信息安全防护臻于完善，保障我们企业之权益。",
  "investor_552":"113年组织信息安全教育训练或培训共531小时，包含针对一般员工之社交工程教育训练、法治教育训练439小时，以及资安执行小组成员训练92小时。",
  "investor_553":"第一届第十八次",
  "investor_554":"第一届第十九次",
  "investor_555":"第一届第二十次",
  "investor_556":"第二届第一次",
  "investor_557":"第二届第二次",
  "investor_558":"第二届第三次",
  "investor_559":"112.01.17",
  "investor_560":"112.03.23",
  "investor_561":"112.05.04",
  "investor_562":"112.08.10",
  "investor_563":"112.11.09",
  "investor_564":"112.12.20",
  "investor_565":"1.拟资金贷与子公司八方云集餐饮股份有限公司新台币1亿元额度案",
  "investor_566":"2.拟资金贷与子公司Bafang Yunji Foods LLC美金150万元及资金贷与子公司Bafang Yunji Restaurant Group LLC美金300万元案",
  "investor_567":"3.拟为子公司丹堤咖啡食品股份有限公司背书保证案",
  "investor_568":"4.拟为子公司Bafang Yunji Foods LLC及Bafang Yunji Restaurant Group LLC提供背书保证案",
  "investor_569":"5.拟修订本公司「公司治理实务守则」案",
  "investor_570":"1.111年度决算表册案",
  "investor_571":"2.本公司111年度盈余分配案",
  "investor_572":"3.112年度会计师公费暨独立性评估审核案",
  "investor_573":"4.拟通过本公司之「内部控制制度声明书」案",
  "investor_574":"5.拟为子公司丹堤咖啡食品股份有限公司背书保证案",
  "investor_575":"1.拟通过本公司2023年第1季合并财务报表案",
  "investor_576":"2.拟订定本公司「关系人相互间财务业务相关作业规范」，同时废止「关系人交易管理办法」案",
  "investor_577":"3.拟订定本公司「签证会计师提供非确信服务预先核准之审核办法」案",
  "investor_578":"4.拟预先核准2023年签证会计师提供非确信服务项目案",
  "investor_579":"1.拟通过本公司2023年第2季合并财务报表案",
  "investor_580":"2.112年上半年度盈余分配案",
  "investor_581":"3.拟取得不动产案",
  "investor_582":"4.拟增资子公司丹堤咖啡食品股份有限公司案",
  "investor_583":"5.本公司2023年度对「财团法人新北市私立八方云集社会福利慈善事业基金会」捐赠新台币三百万元案",
  "investor_584":"1.拟通过本公司2023年第3季合并财务报表案",
  "investor_585":"2.拟增资100%转投资子公司Bafang Yunji International (USA) Limited及间接投资设立美国子公司案",
  "investor_586":"3.拟解散清算香港子公司八方云集餐饮连锁集团有限公司案",
  "investor_587":"4.拟订定本公司113年度稽核计划案",
  "investor_588":"1.本公司拟于嘉义县大林镇兴建蔬菜冷藏库案",
  "investor_589":"2.本公司拟于淡水天元段厂房建置新产线案",
  "investor_590":"内部稽核目的",
  "investor_591":"在促进公司健全经营并建立良好之内部控制制度，协助董事会及经理人评估及复核内部控制制度之缺失，及衡量营运之效果及效率，并适时提供改进建议，以确保内部控制制度得以持续有效实施，及作为检讨修正内部控制制度之依据。",
  "investor_592":"内部稽核组织",
  "investor_593":"本公司稽核室为一独立单位，隶属于董事会，稽核室含稽核主管共编制五名。组织结构如下：",
  "investor_594":"内部稽核之运作",
  "investor_595":"本公司稽核工作主要依据董事会通过的年度稽核计划执行，该稽核计划系参照风险评估结果拟订，另视营运需要不定期安排项目稽核。",
  "investor_596":"内部稽核作业完成后，本室会将查核结果与受查单位充分沟通，并据实揭露于稽核报告呈核，而对于受查单位之改善对策亦加以追踪至改善为止。",
  "investor_597":"稽核报告(含追踪报告)除于完成之次月底前交付各独立董事查阅外，内部稽核主管于每次召开之审计委员会及董事会中进行报告，并在每季进行一次与独立董事单独报告会议。",
  "investor_598":"内部稽核复核各单位所执行的自行检查，包括检查该作业是否执行并复核文件以确保执行的质量，并综合自行检查结果，并向审计委员会及董事会报告，以作为评估整体内部控制制度有效性及出具内部控制制度声明书之依据。",
  "investor_599":"内部稽核人员任免、考核与薪资报酬",
  "investor_600":"本公司内部稽核人员任用资格符合金融监督管理委员会规定之适任条件，内部稽核主管之任免，经审计委员会同意，并提董事会决议通过。另内部稽核人员之考核系依据「绩效考核办法」每年执行二次，并由内部稽核主管呈报董事长核定。",
  "investor_601":"第五届董事会",
  "investor_602":"(任期112年6月15日-115年6月14日)",
  "investor_603":"董事会成员",
  "investor_604":"董事会绩效评估",
  "investor_605":"为落实公司治理并提升本公司董事会功能，建立绩效目标以加强董事会运作效能，本公司已于110年4月8日由董事会通过本公司董事会绩效评估办法，每年执行内部董事会绩效评估，应至少每三年由外部专业独立机构或外部专家学者团执行评估一次。评估对象包含整体董事会(含功能性委员会)及个别董事成员之绩效表现。而董事会内部及外部绩效评估结果，应于次一年度第一季结束前完成。",
  "investor_606":"●董事会、董事成员及功能性委员会之内部绩效评估报告",
  "investor_607":"113年度",
  "investor_P01":"member231228TW.jpg",
  "ESG_00":"企业永续",
  "ESG_01":"永續發展實務",
  "ESG_02":"利害关系人",
  "ESG_03":"永续发展",
  "ESG_04":"人权政策",
  "ESG_001":"八方云集成立永续发展推动组并经由内部问卷与跨部门讨论，111年度鉴别出主要利害关系人有员工、加盟主、供货商、消费者、主管机关、投资人及小区居民，为我们主要的沟通对象。",
  "ESG_002":"与利害关系人沟通",
  "ESG_0021":"八方云集重视各利害关系人所关注的议题，并将其纳入公司管理方针与执行计划的参考。本公司之發言人及代理發言人為利害關係人主要溝通管道，並於公司官網及公開資訊觀測站上均設有聯絡方式及信箱，以多元的沟通管道揭露信息，确保能与利害关系人获得有效且良好之沟通成果。",
  "ESG_003":"本公司董事会订定「永续发展实务守则」，并依守则规范执行运作。指定公司治理室为推动永续发展之兼职单位，成立永续发展推动组，定期向董事会报告永续发展政策、制度或相关管理方针及计划之提出及执行。111年于永续发展推动小组辖下成立「温室气体盘查及查证小组」，并向董事会报告每季至少一次，111年已进行4次有关气候变迁温室气体相关进度汇报。 112年6月成立「风险管理委员会」后，「温室气体盘查及查证小组」除仍维持每季向董事会汇报温室气体相关执行情形外，由风险管理委员会负责气候变迁风险管理相关运作机制之监督。",
  "ESG_0030":"订定「企业社会责任守则」",
  "ESG_0031":"挂牌上市",
  "ESG_0032":"成立永续发展推动组",
  "ESG_0033":"发布第1本永续报告书",
  "ESG_0034":"发布第1本英文永续报告书",
  "ESG_0035":"修订「企业社会责任实务守则」并更名为「永续发展实务守则」",
  "ESG_0036":"拟订「永续报告书编制及验证之作业程序」",
  "ESG_0037":"发布第2本永续报告书",
  "ESG_0038":"发布第2本英文永续报告书",
  "ESG_0039":"Implementation of Social Welfare in 2023",
  "ESG_077":"本公司致力维护员工基本人权，认同并支持「联合国全球盟约」、「联合国世界人权宣言」及「国际劳工组织工作基本原则与权利宣言」等国际公认之人权标准，以实际行动体现本公司尊重与保护人权之责任，遵守公司所在地劳动、性别工作平等相关法规规范，禁止强迫、杜绝任何侵犯及违反人权的行为。本公司的人权政策包含对多元的包容性及确保工作机会均等；遵循劳动法令规范，确保雇用政策无差别待遇且不强迫劳动。禁止年龄歧视，保障中高龄者劳动权益，建构友善就业环境；及不非法雇用童工。",
  "ESG_078":"落实职场多元性，不因员工个人性别(含性倾向)、种族、阶级、年龄、婚姻、语言、思想、宗教、党派、籍贯、出生地、容貌、五官及身心障碍等，而有差别待遇或任何形式之歧视。",
  "ESG_079":"本公司亦订有完善的福利措施，休假及其他福利则依循劳基法规定并制定于工作规则，并设有职福会提供多元的福利照护。另本公司已于章程明定保留提拨不低于1%之员工酬劳，制订「员工酬劳实施办法」，将经营绩效成果反映于员工。",
  "store_1": "输入店名或路名搜寻",
  "store_2_0": "县市",
  "store_2": "选择县市",
  "store_3_0": "区域",
  "store_3": "选择区域",
  "store_4": "提供面点",
  "store_4_0": "在线订餐",
  "store_5_0": "付款方式",
  "store_5": "支付方式 / 可复选支付方式",
  "store_6_0": "活动筛选",
  "store_6_1": "活动",
  "store_6": "活动筛选 / 可复选活动",
  "store_7": "立即搜寻",
  "store_7_0": "立即搜寻",
  "store_8": "地址",
  "store_9": "电话",
  "store_10": "营业时间",
  "store_11": "在线订餐",
  "news_1": "最新消息",
  "news_2": "重要公告",
  "news_3": "新品上市",
  "news_4": "分类",
  "news_5": "发布日期",
  "news_6": "上一篇",
  "news_7": "下一篇",
  "news_8": "更多内容",
  "contact_1": "常见问题",
  "contact_2": "意见反应",
  "contact_3": "我要加盟",
  "contact_4": "人才招募",
  "contact_5": "主旨",
  "contact_6": "回复方式",
  "contact_7": "填表人",
  "contact_8": "电话",
  "contact_9": "反应门市",
  "contact_10": "内容",
  "contact_11": "信箱",
  "contact_12": "内容",
  "contact_13": "上传档案",
  "contact_14": "验证码",
  "contact_15": "我已经阅读及同意个资条款",
  "contact_16": "确认送出",
  "contact_17": "倾听您的建议 免付费客服",
  "contact_18": "请问在哪里可以看到八方云集的店家信息?",
  "contact_19": "请点选我们官网上的门市信息字段，即可查询所有八方云集台湾门市的地址及电话。",
  "contact_20": "请问店家的营业时间是?",
  "contact_21": "每家店的营业时间会依照当店的产品实际销售状况有所不同，建议可直接拨打电话向店家询问营业时间。",
  "contact_22": "请问你们每家店的价格都一样吗?",
  "contact_23": "因地域性的不同，所以不同区的店家在价格上会有稍许的落差。",
  "contact_24": "请问有菜单吗？",
  "contact_25": "因每家门店贩卖商品不一，建议可直接向欲购买门店索取纸本菜单。",
  "contact_26": "请问XX锅贴/水饺的热量多少？",
  "contact_27": "我们官网上的安心餐点选项，都有标注每份餐点的热量。",
  "contact_28": "请问小菜跟豆浆有整包贩卖吗？",
  "contact_29": "有的，但因物料为每天总公司配送至店家，建议可事先向店家订购。",
  "contact_30": "请问要怎么样加盟八方云集?",
  "contact_31": "您可在官网的「联络我们」里填写加盟询问窗体，我们将有专人尽快与您联系。",
  "contact_32": "请问你们的产品有添加麻油吗？",
  "contact_33": "我们的馅料都有加麻油，除珍珠馅没有。",
  "contact_34": "请问你们的产品有添加奶蛋过敏原吗？",
  "contact_35": "目前工厂生产的所有品项皆无直接添加蛋、奶于产品中，原物料本身则不在此限。",
  "contact_36": "请问你们的新蔬食产品内馅有什么？",
  "contact_37": "为全蔬食制作绞肉、高丽菜、小麦蛋白。",
  "contact_38": "请问门店有提供什么支付方式？",
  "contact_39": "依各家门店合作状况，可上官网门市信息查询。",
  "contact_40": "请问为什么外送平台的价格跟店家不一样？",
  "contact_41": "因外送店家与平台配合会有额外的成本，透过平台订购会与现场价格不同，若有价格考虑，建议您也可以直接到店家购买。",
  "contact_42": "请问多少钱可以外送?",
  "contact_43": "因地区性不同，所以店家外送门坎也会有所不同，如需外送服务可直接向欲订购的门市查询当店外送之最低金额，店内人员会依据外送地点之远近及当日店内人力配置，告知是否可提供外送服务。",
  "contact_44": "请问有贩卖冷冻锅贴吗？",
  "contact_45": "有的，可向门店事先询问订购。",
  "contact_46": "请问为何你们的豆浆保存期限这么短？",
  "contact_47": "因产品未添加防腐剂，开封后须尽快饮用完毕，以低温保存且切勿碰到生水，避免变质。",
  "contact_48": "请问你们豆浆使用的黄豆是非基改的吗?",
  "contact_49": "我们的豆浆采用非基改的黄豆，且无添加防腐剂及人工香料，敬请安心食用。",
  "contact_50": "请问为什么买你们的生鲜水饺回家煮都会煮破？",
  "contact_51": "因烹煮方式及时间皆会影响，请务必于水滚后再下水饺烹煮。",
  "contact_52": "请问吃锅边素在八方云集可以点哪些餐点?",
  "contact_53": "吃锅边素可以点麻酱干面、新蔬食锅贴或水饺，吃纯素的客人则可购买新蔬食生鲜锅贴或水饺回家自行烹煮。",
  "contact_54": "请问有些水饺跟锅贴皮是有颜色的，是加了色素吗?",
  "contact_55": "我们的水饺皮跟锅贴皮是完全不加色素及防腐剂的，绿皮是使用绿藻粉、玉米皮跟咖哩皮是加了姜黄粉，因此可安心食用。",
  "contact_56": "为何有些店有开发票，有些店没有开发票?",
  "contact_57": "每一家加盟店都是独立的商号，在申请商号时会由当地税捐单位核定是否需要开立统一发票，但无论是否开立发票，店家都还是要缴税。",
  "contact_58": "服务相关",
  "contact_59": "产品相关",
  "contact_60": "卫生相关",
  "contact_61": "业务相关",
  "contact_62": "其他",
  "contact_63": "感谢您浏览本网站，请详细填写以下窗体并清楚告诉我们您的要求，我们收到留言将尽快与您连络，再次感谢您。",
  "contact_65": "请输入您的名称",
  "contact_66": "请输入您的电话",
  "contact_67": "请输入您的信箱",
  "contact_68": "请输入门市名称",
  "contact_69": "请输入您的内容",
  "contact_70": "未选择任何档案",
  "contact_72": "请输入验证码",
  "contact_73": "请选择主旨",
  "contact_74": "请选择回复方式",
  "join_1": "想加入我们的行列吗?欢迎来填写加盟意愿表!",
  "join_2": "姓名",
  "join_3": "请输入姓名",
  "join_4": "性别",
  "join_5": "男性",
  "join_6": "女性",
  "join_7": "年龄",
  "join_8": "请输入您的年龄",
  "join_9": "电话",
  "join_10": "请输入您的电话",
  "join_11": "加盟区域",
  "join_12": "婚姻",
  "join_13": "已婚",
  "join_14": "未婚",
  "join_15": "信箱",
  "join_16": "请输入电子信箱",
  "join_17": "地址",
  "join_18": "请输入邮政编码",
  "join_19": "请填写详细地址",
  "join_20": "工作经验",
  "join_21": "请选择县市",
  "join_22": "请选择区域",
  "feedbackTitle": "成功送出",
  "feedbackTip": "感谢您告诉我们您的要求，我们将尽快与您连络，再次感谢您。",
  "ok": "确认",
  "emailError": "信箱格式输入错误",
  "phoneError": "电话格式输入错误",

  "pleseSelect":"请选择",
  "check":"请勾选同意条款"

}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js